import React from 'react';
import { ArrowRight, BookOpen } from 'lucide-react';
import SEO from '../components/SEO';

export default function BlogPage() {
    const posts = [
        {
            id: 1,
            title: "Top 5 Smartphones to Look Out for in 2026",
            category: "Mobile",
            date: "March 15, 2026",
            excerpt: "Discover the cutting-edge features and stunning designs of this year's most anticipated mobile devices. We review cameras, batteries, and ultimate performance.",
            image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=800&auto=format&fit=crop"
        },
        {
            id: 2,
            title: "Choosing the Perfect Frames for Your Face Shape",
            category: "Optical",
            date: "February 28, 2026",
            excerpt: "Round, square, or heart-shaped? Our comprehensive guide helps you effortlessly navigate our optical collection to find frames that complement your unique features.",
            image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?q=80&w=800&auto=format&fit=crop"
        },
        {
            id: 3,
            title: "The Ultimate Guide to Digital Gift Cards",
            category: "Gift Cards",
            date: "January 10, 2026",
            excerpt: "Why digital gift cards are the perfect present for any occasion. Learn how to securely purchase and redeem Razorpay powered gift cards on Nso-India.",
            image: "https://images.unsplash.com/photo-1620608779836-39af13c1fcf4?q=80&w=800&auto=format&fit=crop"
        }
    ];

    return (
        <div className="min-h-screen bg-white" data-testid="blog-page">
            <SEO 
                title="Blog | Best Buying Guilds with the Top Quality" 
                description="Explore the Best Collection with the top quality and trending products guidance with the Best e-commerce platform, NSO-India, Blog section." 
            />
            {/* Hero Section */}
            <section className="bg-surface py-20 md:py-32">
                <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
                    <span className="text-sm uppercase tracking-widest text-primary font-body font-semibold mb-4 block flex items-center justify-center gap-2">
                        <BookOpen className="w-4 h-4" /> Nso-India Insights
                    </span>
                    <h1 className="font-heading text-4xl md:text-6xl text-secondary mb-6">Our Blog</h1>
                    <p className="font-body text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                        Stay updated with the latest trends in eyewear, mobile technology, and ultimate gifting solutions.
                    </p>
                </div>
            </section>

            {/* Featured Post List */}
            <section className="py-16 md:py-24">
                <div className="max-w-7xl mx-auto px-4 md:px-8">
                    <div className="grid lg:grid-cols-3 gap-8">
                        {posts.map((post) => (
                            <article key={post.id} className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-soft transition-all duration-300 border border-gray-100 flex flex-col">
                                <div className="relative aspect-[16/10] overflow-hidden bg-surface">
                                    <img
                                        src={post.image}
                                        alt={post.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md px-4 py-1.5 rounded-full text-xs font-body font-semibold text-primary uppercase tracking-wider shadow-sm">
                                        {post.category}
                                    </div>
                                </div>
                                <div className="p-8 flex flex-col flex-grow">
                                    <time className="text-xs font-body font-medium text-muted-foreground uppercase tracking-widest mb-3 block">
                                        {post.date}
                                    </time>
                                    <h3 className="font-heading text-2xl text-secondary mb-4 leading-snug group-hover:text-primary transition-colors cursor-pointer">
                                        {post.title}
                                    </h3>
                                    <p className="font-body text-muted-foreground text-sm leading-relaxed mb-6 flex-grow">
                                        {post.excerpt}
                                    </p>
                                    <button className="flex items-center text-sm font-body font-semibold text-primary group-hover:gap-3 gap-2 transition-all mt-auto cursor-pointer">
                                        Read Article <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>
                            </article>
                        ))}
                    </div>

                    <div className="text-center mt-16 pt-8 border-t border-gray-100">
                        <p className="font-body text-muted-foreground mb-6">Want to stay updated?</p>
                        <div className="flex max-w-md mx-auto relative relative">
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="w-full pl-6 pr-32 py-4 rounded-full bg-surface border-transparent focus:border-primary focus:ring-2 focus:ring-primary/20 font-body transition-all"
                            />
                            <button className="absolute right-2 top-2 bottom-2 bg-primary hover:bg-primary/90 text-white px-6 rounded-full font-body text-sm transition-all focus:ring-2 focus:ring-offset-2 focus:ring-primary">
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
